import type { BatchPeekContext, ShipmentPeekContext } from "@/components/hub/entityPeekTypes";

import type { CartonRow } from "./prepackApi";
import { plannedPhysicalSerials } from "./prepackPhysicalDevices";

/** Carton-scoped batch peek from the queue/carton DTO (no manufacturing peek API). */
export function prepackCartonBatchPeek(carton: CartonRow): BatchPeekContext {
  const finishedSkuLines = carton.items.map((item) => ({
    sku: item.sku,
    quantity: plannedPhysicalSerials(item),
  }));
  return {
    mfr_ship_by_date: carton.mfrShipByDate,
    line_count: carton.items.length,
    serial_count: finishedSkuLines.reduce((sum, line) => sum + line.quantity, 0),
    finished_sku_lines: finishedSkuLines,
  };
}

/** Planned ship-by from the carton DTO. */
export function prepackCartonShipmentPeek(carton: CartonRow): ShipmentPeekContext | undefined {
  if (carton.mfrShipByDate == null) return undefined;
  return { ship_by_date: carton.mfrShipByDate };
}
